// extracted by mini-css-extract-plugin
export default {"wrapper":"ImagesImage_wrapper","globalIcon":"ImagesImage_GLOBAL_icon","fallbackText":"ImagesImage_fallbackText","error":"ImagesImage_error","loaded":"ImagesImage_loaded"};